import { AbstractControl, ValidationErrors } from '@angular/forms';

const CONFLICT_ERROR_KEYS = [
  'conflictName',
  'conflictWithThirdName',
  'conflictWithSecondName',
] as const;

const mergeControlErrors = (
  control: AbstractControl | null,
  errors: ValidationErrors,
) => {
  if (!control) {
    return;
  }

  control.setErrors({
    ...(control.errors ?? {}),
    ...errors,
  });
};

const clearControlErrors = (
  control: AbstractControl | null,
  keys: readonly string[],
) => {
  if (!control?.errors) {
    return;
  }

  const nextErrors = {...control.errors};

  keys.forEach((key) => {
    delete nextErrors[key];
  });

  control.setErrors(Object.keys(nextErrors).length ? nextErrors : null);
};

export const uniqueCompanyNameValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const secondNameControl = control.get('secondName');
  const thirdNameControl = control.get('thirdName');
  const name = (control.get('name')?.value || '').trim();
  const secondName = (secondNameControl?.value || '').trim();
  const thirdName = (thirdNameControl?.value || '').trim();

  clearControlErrors(secondNameControl, CONFLICT_ERROR_KEYS);
  clearControlErrors(thirdNameControl, CONFLICT_ERROR_KEYS);

  const groupErrors: ValidationErrors = {};

  if (name && secondName && name === secondName) {
    groupErrors.conflictName = true;
    mergeControlErrors(secondNameControl, {conflictName: true});
  }

  if (name && thirdName && name === thirdName) {
    groupErrors.conflictName = true;
    mergeControlErrors(thirdNameControl, {conflictName: true});
  }

  if (secondName && thirdName && secondName === thirdName) {
    groupErrors.conflictWithThirdName = true;
    groupErrors.conflictWithSecondName = true;
    mergeControlErrors(secondNameControl, {conflictWithThirdName: true});
    mergeControlErrors(thirdNameControl, {conflictWithSecondName: true});
  }

  return Object.keys(groupErrors).length ? groupErrors : null;
};
